export default __webpack_public_path__ + "static/media/avatar_elephant3.734469d8.mp3";